// Timing + sizing knobs for the dialogue callout. Kept as pure data so future
// subjects / classes can tune behavior without touching the component.

export const BUBBLE_MAX_CHARS = 90;
export const FADE_SWAP_MS = 220;

// Wait-time after a new exercise renders before the 💡 Tipp button is tappable.
// Cognitive-science-backed: forces reflective thinking before asking for help.
export const HINT_WAIT_TIME_MS = 6000;

export function truncate(text: string, maxChars = BUBBLE_MAX_CHARS): string {
  if (!text) return '';
  const clean = text.trim();
  if (clean.length <= maxChars) return clean;
  const cut = clean.slice(0, maxChars - 1);
  const lastSpace = cut.lastIndexOf(' ');
  return (lastSpace > 40 ? cut.slice(0, lastSpace) : cut) + '…';
}
